import { render, staticRenderFns } from "./download.vue?vue&type=template&id=5913f860&scoped=true&"
var script = {}
import style0 from "./download.vue?vue&type=style&index=0&id=5913f860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5913f860",
  null
  
)

export default component.exports